import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PdfSettingsModel } from '../../models';

@Component({
  selector: 'rnpl-pdf-billing',
  templateUrl: './pdf-billing.component.html',
  styleUrls: ['./pdf-billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfBillingComponent {

  @Input() pdfSettings: PdfSettingsModel;
  @Input() currentShortYear: string;

}
